import React from 'react';
import { useSelector } from 'react-redux';
import { FiUser, FiMail, FiShield, FiClock, FiCalendar } from 'react-icons/fi';
import Layout from '../components/layout/Layout';
import Card from '../components/common/Card';
import './Profile.css';

const Profile = () => {
  const { user } = useSelector((state) => state.auth);

  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    return new Date(dateString).toLocaleString();
  };

  const getPermissionLabel = (permission) => {
    const labels = {
      'view_transactions': 'View Transactions',
      'manage_transactions': 'Manage Transactions',
      'manage_projects': 'Manage Projects',
      'manage_webhooks': 'Manage Webhooks',
      'manage_ip_whitelist': 'Manage IP Whitelist',
      'view_logs': 'View Logs',
      'manage_team': 'Manage Team'
    };
    return labels[permission] || permission;
  };

  return (
    <Layout title="Profile">
      <div className="profile-page">
        <div className="profile-grid">
          <Card title="User Information" className="profile-card">
            <div className="profile-header">
              <div className="profile-avatar">
                {user?.name?.charAt(0) || 'U'}
              </div>
              <div className="profile-info">
                <h2 className="profile-name">{user?.name}</h2>
                <span className={`role-badge role-${user?.role}`}>
                  {user?.role}
                </span>
              </div>
            </div>

            <div className="profile-details">
              <div className="detail-item">
                <FiMail className="detail-icon" />
                <div className="detail-content">
                  <span className="detail-label">Email</span>
                  <span className="detail-value">{user?.email}</span>
                </div>
              </div>

              <div className="detail-item">
                <FiShield className="detail-icon" />
                <div className="detail-content">
                  <span className="detail-label">Role</span>
                  <span className="detail-value">{user?.role}</span>
                </div>
              </div>

              <div className="detail-item">
                <FiClock className="detail-icon" />
                <div className="detail-content">
                  <span className="detail-label">Last Login</span>
                  <span className="detail-value">{formatDate(user?.lastLogin)}</span>
                </div>
              </div>

              <div className="detail-item">
                <FiCalendar className="detail-icon" />
                <div className="detail-content">
                  <span className="detail-label">Account Created</span>
                  <span className="detail-value">{formatDate(user?.createdAt)}</span>
                </div>
              </div>
            </div>
          </Card>

          <Card title="Permissions" className="permissions-card">
            <div className="permissions-list">
              {user?.permissions?.length > 0 ? (
                user.permissions.map((permission, index) => (
                  <div key={index} className="permission-item">
                    <FiShield className="permission-icon" />
                    <span>{getPermissionLabel(permission)}</span>
                  </div>
                ))
              ) : (
                <p className="no-permissions">No specific permissions assigned</p>
              )}
            </div>
            {user?.role === 'admin' && (
              <div className="admin-note">
                <FiUser />
                <span>As an admin, you have full access to all features.</span>
              </div>
            )}
          </Card>
        </div>
      </div>
    </Layout>
  );
};

export default Profile;
